/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React, { useState, useEffect } from 'react';
import { i18n, mediaQuery } from 'src/common';

interface HeaderWidgetProps {
  active: boolean;
}

const HeaderWidgetStyle = styled.div({
  background: "#C5F7E2",
  padding: '5px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  fontSize: '10px',
  height: '40px',

  [mediaQuery('laptopL')]: {
    fontSize: '14px',
  },
});

const CountdownStyle = styled.span({
  fontWeight: 'bold'
});

const getTimeUntilMidnight = () => {
  const now = new Date();
  const midnight = new Date();
  midnight.setDate(midnight.getDate() + 1);
  midnight.setHours(0, 0, 0, 0);
  
  const diff = midnight.getTime() - now.getTime();
  
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  
  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
  };
};

export const HeaderWidget: React.FC<HeaderWidgetProps> = ({ active }: HeaderWidgetProps) => {
  const [countdown, setCountdown] = useState(getTimeUntilMidnight());

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(getTimeUntilMidnight());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  if (!active) return null;
  return (
    <HeaderWidgetStyle>
      {i18n.t('layout.header.widgetTitle')}
      <CountdownStyle>
        {countdown.hours}:{countdown.minutes}:{countdown.seconds}
      </CountdownStyle>
    </HeaderWidgetStyle>
  );
};